import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	compass: {
		id: 'compass.components-left-panel.header',
		defaultMessage: 'Compass',
		description: 'The text is for the left panel header about compass brand name',
	},
	title: {
		id: 'compass.components-left-panel.title',
		defaultMessage:
			'Create a catalog of your repositories linked in Jira and measure the health and performance of it for free',
		description: 'The text is for the left panel title',
	},
	description: {
		id: 'compass.components-left-panel.description',
		defaultMessage:
			'Catalog these components and use them to track performance, health, and identify dependencies. Link issues to components – so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward.',
		description: 'The text is for the left panel description',
	},
	createYourCatalogButton: {
		id: 'compass.components-left-panel.create-your-catalog.button',
		defaultMessage: 'Create your catalog in Compass',
		description: 'The text is for the left panel createYourCatalog Button',
	},
	createYourCatalogButtonTip: {
		id: 'compass.components-left-panel.create-your-catalog.buttonTip',
		defaultMessage: "You will provision another product but it's on the free plan",
		description: 'The text is for the left panel createYourCatalogButton tip',
	},
	legalDisclaimer: {
		id: 'compass.components-left-panel.create-your-catalog.legal-disclaimer',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'{boldText}, you agree to the {atlassianCustomerAgreementLink} and {privacyPolicyLink}, and that Atlassian will collect, use and process data from the Github for Jira app you have installed across your Atlassian products in accordance with the {atlassianCustomerAgreementLink} and {privacyPolicyLink}.',
		description: 'The text is for the left panel legal disclaimer for createYourCatalogButton CTA',
	},
	boldText: {
		id: 'compass.components-left-panel.create-your-catalog.legal-disclaimer-bold-text-part',
		defaultMessage: 'By clicking Create your catalog in Compass',
		description: 'The text is for the left panel legal disclaimer for bold style content',
	},
	atlassianCustomerAgreementLink: {
		id: 'compass.components-left-panel.create-your-catalog.atlassian-customer-agreement-link',
		defaultMessage: 'Atlassian Customer Agreement',
		description:
			'The text is for the left panel legal disclaimer for Atlassian Customer Agreement Link',
	},
	privacyPolicyLink: {
		id: 'compass.components-left-panel.create-your-catalog.privacy-policy-link',
		defaultMessage: 'Privacy Policy',
		description: 'The text is for the left panel legal disclaimer for Privacy Policy Link',
	},
});
